import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {InfoListDto, Orders} from "@server-models";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {ILocalInfosMyReadDto} from "@tech/pages/infos/interfaces/infos-my-read-dto.interface";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {ILocalRequestPayload} from "@shared/interfaces/local-request-payload.interface";
import {isString} from "lodash";

@Injectable({
  providedIn: 'root',
})
export class TechInfoService extends CoreHttpClientApiBaseService {

  getInfoList(payload: ILocalRequestPayload): Observable<ILocalPageOutputDto<InfoListDto[]>> {
    const params: Record<string, string> = {
      ...payload.params,
      pageSize: (payload.pagination?.pageSize ?? 10).toString(),
      pageNumber: (payload.pagination?.pageNumber ?? 1).toString(),
      cols: 'Content',
      sortField: 'DateTime',
      sort: Orders.Descending?.toString()
    }

    const endpoint = isString(params['q']) ? '/orga/v2/info/search/filter' : '/orga/v2/info/filter';

    return super.post<ILocalPageOutputDto<InfoListDto[]>>(endpoint, true, payload.filters, { params });
  }

  /**
   * @name postMyReadById
   * @memberof TechInfoService
   * @description
   * Make a post request to Orga server to mark an info as read by id
   * @param id
   */
  postMyReadById(id: number): Observable<ILocalPageOutputDto<ILocalInfosMyReadDto>> {
    return super.post<ILocalPageOutputDto<ILocalInfosMyReadDto>>(`/orga/v2/me/info/${ id }/read`,
      undefined, undefined, undefined);
  }
}
